import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import * as xlsx from "xlsx";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  Button,
  Input,
} from "@nextui-org/react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Checkbox,
  CheckboxGroup,
} from "@nextui-org/react";
import ProfitLossChart from "../../components/ProfitLossChart";

// ==========================================
// SUB-COMPONENTS
// ==========================================

/**
 * Reusable table for displaying summary financial calculations
 */
const SummaryTable = ({ data, className = "" }) => (
  <table
    className={`items-center text-blueGray-700 w-[80%] rounded-lg bg-gray-200 ${className}`}
  >
    <tbody>
      {data.map((item) => (
        <tr className="border-b-1 border-black" key={item.description}>
          <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap p-4 text-left">
            {item.description}
          </th>
          <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-base whitespace-nowrap p-4">
            {item.amount?.toLocaleString("en-IN")}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

/**
 * Component to display the detailed list of trips
 */
const TripDataTable = ({ trips, handleTripDataDownload }) => (
  <>
    <div className="flex items-baseline">
      <h2>Trip Data</h2>
      <i
        className="ml-5 fa-solid fa-file-export text-lg items-baseline text-orange-300 cursor-pointer"
        onClick={handleTripDataDownload}
        title="Download Trip Data"
      ></i>
    </div>
    <div className="flex flex-col w-[25rem] h-[15rem] md:w-[36rem] mb-8 lg:w-[50rem] md:h-[16rem]">
      <div className="-m-1.5 overflow-x-auto bottom-0 inset-x-0">
        <div className="p-1.5 min-w-full inline-block align-middle">
          <div className="border rounded-lg overflow-hidden shadow">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase"></th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    TRIP DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    GPI No.
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    TON
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    LR No
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Truck No.
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Destination
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-smm text-gray-500 uppercase">
                    COMPANY RATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-smm text-gray-500 uppercase">
                    COMPANY TOTAL
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-smm text-gray-500 uppercase">
                    LORRY RATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    LORRY TOTAL
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    ADVANCE AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    ADVANCE AMOUNT DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    DIESEL AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    BALANCE AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    SOLD TO PARTY
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    CONTACT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 1 DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 1 AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 2 DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 2 AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 3 DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    POST PAID 3 AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Extra Amount
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Extra Amount Remark
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Unloading
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Bill NO
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    Bill DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    TOLL BILL NO
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    TOLL AMOUNT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    TOLL BILL DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    3 POINT BILL
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-smm text-gray-500 uppercase">
                    3 POINT AMT
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    3 POINT DATE
                  </th>
                  <th className="font-bold px-6 py-3 text-start text-sm text-gray-500 uppercase">
                    INCENTIVE AMOUNT
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {trips?.map((t, index) => (
                  <tr key={index} className="hover:bg-gray-300 cursor-pointer">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {index + 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {new Date(t?.tripDate).toLocaleDateString("en-GB") +
                        " - " +
                        new Date(t?.tripDate).toLocaleTimeString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.gpiNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.ton}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.lrNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.truckNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.destination}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.companyRate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.companyTotal}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.lorryRate}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.lorryTotal}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.advancedAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t.advancedAmountDate
                        ? new Date(t?.advancedAmountDate).toLocaleDateString(
                            "en-GB",
                          )
                        : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.dieselAmount}
                    </td>
                    <td
                      className={`${t?.balanceAmount === 0 && t?.lorryRate !== 0 ? "text-green-600 font-bold bg-green-100" : t?.balanceAmount < 0 ? "text-red-500 font-bold bg-red-100" : "text-black"} px-6 py-4 whitespace-nowrap text-sm font-medium`}
                    >
                      {t?.balanceAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.soldToParty}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.contactNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaidDate
                        ? new Date(t?.postPaidDate)?.toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaidAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaid2Date
                        ? new Date(t?.postPaid2Date)?.toLocaleDateString(
                            "en-GB",
                          )
                        : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaid2Amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaid3Date
                        ? new Date(t?.postPaid3Date)?.toLocaleDateString(
                            "en-GB",
                          )
                        : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.postPaid3Amount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.extraAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.extraAmountRemark}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.unloading}
                    </td>
                    <td
                      className={
                        t?.billNo
                          ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium"
                          : null
                      }
                    >
                      {t?.billNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.billDate
                        ? new Date(t?.billDate).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td
                      className={
                        t?.tollBillNo
                          ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium"
                          : null
                      }
                    >
                      {t?.tollBillNo}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.tollAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.tollDate
                        ? new Date(t?.tollDate).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td
                      className={
                        t?.threePointBill
                          ? "text-green-700 bg-green-100 px-6 py-4 whitespace-nowrap text-sm font-medium"
                          : null
                      }
                    >
                      {t?.threePointBill}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">
                      {t?.threePointAmount}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">
                      {t?.threePointDate
                        ? new Date(t?.threePointDate).toLocaleDateString(
                            "en-GB",
                          )
                        : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium ">
                      {t?.incentiveAmount}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </>
);

const Analytics = () => {
  //Modal of Next UI
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  // state to overall analytics toggle chart
  const [showChart, setShowChart] = useState(false);
  const [chartData, setChartData] = useState([]);

  // range chart states
  const [showRangeChart, setShowRangeChart] = useState(false);
  const [rangeChartData, setRangeChartData] = useState([]);

  // till date chart states
  const [showTillDateChart, setShowTillDateChart] = useState(false);
  const [tillDateChartData, setTillDateChartData] = useState([]);

  const [loading, setloading] = useState(true);

  // --- OVERALL ANALYTICS STATES ---
  const [profit, setProfit] = useState();
  const [expense, setexpense] = useState(0);
  const [incentive, setIncentive] = useState(0);
  const [company, setCompany] = useState();
  const [lorry, setLorry] = useState();
  const [lorryBalance, setLorryBalance] = useState();
  const [companyIncoming, setCompanyIncoming] = useState(0);
  const [extraAmount, setExtraAmount] = useState();
  const [netProfit, setNetProfit] = useState(); //actual estimated profit based on dynamic difference of company and lorry rate

  // --- RANGE ANALYTICS STATES ---
  const [showDownloadIcon, setShowDownloadIcon] = useState(false);
  const [trips, setTrips] = useState();
  const [profitDateWise, setProfitDateWise] = useState(0);
  const [netProfitDateWise, setNetProfitDateWise] = useState(0); // actual estimated profit based on dynamic difference of company and lorry rate in date range
  const [incentiveDateWise, setIncentiveDateWise] = useState(0);
  const [lorryDateWise, setLorryDateWise] = useState(0);
  const [companyDateWise, setCompanyDateWise] = useState(0);
  const [companyIncomingDateWise, setCompanyIncomingDateWise] = useState(0);
  const [lorryBalDateWise, setLorryBalDateWise] = useState(0);
  const [expenseDateWise, setExpenseDateWise] = useState(0);

  const [showDownloadIconGivenDate, setShowDownloadIconGivenDate] =
    useState(false);

  // --- TILL DATE ANALYTICS STATES ---
  const [lorrySum, setLorrySum] = useState();
  const [companySum, setCompanySum] = useState();
  const [threshold, setThreshold] = useState();
  const [companyBalanceTillDate, setCompanyBalanceTillDate] = useState();
  const [extraAmtTillDate, setExtraAmtTillDate] = useState();
  const [incentiveTillDate, setIncentiveTillDate] = useState();
  const [incomingCompanyBalanceTillDate, setIncomingCompanyBalanceTillDate] =
    useState();

  const [profitTillDate, setProfitTillDate] = useState();
  const [netProfitTillDate, setNetProfitTillDate] = useState();
  const [expenseTillDate, setExpenseTillDate] = useState();

  const [thresholds, setThresholds] = useState([]);

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.user);
  useEffect(() => {
    if (user.role !== "Admin") {
      navigate("/home");
    }
  });

  // function to render chart for all
  const getChart = () => {
    const data = getFinancialDataList("overall");
    setChartData([
      data[4].amount,
      data[5].amount,
      data[6].amount,
      data[7].amount,
    ]);
    setShowChart(!showChart);
  };

  // function to get range chart
  const getRangeChart = () => {
    const data = getFinancialDataList("range");
    setRangeChartData([
      data[4].amount,
      data[5].amount,
      data[6].amount,
      data[7].amount,
    ]);
    setShowRangeChart(true);
  };

  // function to get range chart
  const getTillDateChart = () => {
    const data = getFinancialDataList("tillDate");
    setTillDateChartData([
      data[4].amount,
      data[5].amount,
      data[6].amount,
      data[7].amount,
    ]);
    setShowTillDateChart(true);
  };

  const getOverallProfit = async () => {
    try {
      setloading(true);
      const response = await axios.get("/trip/get/overAllProfit");
      setloading(false);
      if (response.data.success) {
        setProfit(response.data.profit);
      }
    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  };

  const getOverallTotalOf3 = async () => {
    try {
      setloading(true);
      const response = await axios.get("/trip/get/comp-lorry-balance-total");
      setloading(false);
      if (response.data.success) {
        setCompany(response.data.overallCompanyTotal);
        setLorry(response.data.overallLorryTotal);
        setLorryBalance(response.data.overallLorryBalance);
      }
    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  };

  const getOverallTotalIncentive = async () => {
    try {
      setloading(true);
      const response = await axios.get("trip/get/totalIncentive");
      setloading(false);
      if (response.data.success) {
        setIncentive(response.data.sumOfIncentive);
      }
    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  };
  const getOverallTotalExpenses = async () => {
    try {
      setloading(true);
      const response = await axios.get("expenses/get/overAllTotalExpenses");
      setloading(false);
      if (response.data.success) {
        setexpense(response.data.totalExpense);
      }
    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  };

  const getCompanyIncoming = async () => {
    try {
      setloading(true);
      const response = await axios.get(
        "/trip/get/overallIncomingCompanyBalance",
      );
      setloading(false);
      if (response.data.success) {
        setCompanyIncoming(response.data.incomingCompanyBalance);
      }
    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  };

  const getSumOfExtraAmount = async () => {
    try {
      const response = await axios.get("/trip/get/sumOfExtraAmount");

      if (response.data.success) {
        setExtraAmount(response.data.sumOfExtraAmount);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const getNetProfitOnDynamicTon = async () => {
    try {
      const response = await axios.get("/trip/get/net-profit/");
      if (response.data.success) {
        setNetProfit(response.data.netProfit);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getOverallProfit();
    getOverallTotalOf3();
    getOverallTotalExpenses();
    getOverallTotalIncentive();
    getCompanyIncoming();
    getSumOfExtraAmount();

    if (process.env.REACT_APP_LOGO_NAME === "LOGISTICS ICL") {
      getNetProfitOnDynamicTon();
    }
  }, []);

  // fetch data by date range
  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowRangeChart(false);

    try {
      const form = new FormData(e.target);
      const data = Object.fromEntries(form.entries());

      if (data.startDate === "" && data.endDate === "") {
        toast.error("required fields");
        return;
      }

      if (process.env.REACT_APP_LOGO_NAME === "LOGISTICS ICL") {
        const response6 = await axios.get(
          `trip/get/net-profit/byRange?startDate=${data.startDate}&endDate=${data.endDate}`,
        );
        if (response6.data.success) {
          setNetProfitDateWise(response6.data.netProfit);
        }
      } else {
        const response1 = await axios.get(
          `trip/get/profitByGivenRange?startDate=${data.startDate}&endDate=${data.endDate}`,
        );
        if (response1.data.success) {
          setProfitDateWise(response1.data.profit);
        }
      }

      const response2 = await axios.get(
        `trip/get/LorryAndCompanyAndBalanceTotalByRange?startDate=${data.startDate}&endDate=${data.endDate}`,
      );

      const response3 = await axios.get(
        `/expenses/get/OverAllTotalExpensesByRange?startDate=${data.startDate}&endDate=${data.endDate}`,
      );

      const response4 = await axios.get(
        `/trip/get/incomingCompanyBalanceByRange?startDate=${data.startDate}&endDate= ${data.endDate}`,
      );

      const response5 = await axios.get(
        `/trip/get/totalIncentiveByDate?startDate=${data.startDate}&endDate=${data.endDate}`,
      );

      if (
        response2.data.success &&
        response3.data.success &&
        response4.data.success &&
        response5.data.success
      ) {
        setLorryDateWise(response2.data.lorryTotal);
        setCompanyDateWise(response2.data.companyTotal);
        setLorryBalDateWise(response2.data.lorryBalance);
        setExpenseDateWise(response3.data.expense);
        setCompanyIncomingDateWise(response4.data.incomingCompanyBalance);
        setIncentiveDateWise(response5.data.sumOfIncentive);
        setShowDownloadIcon(true);
      }

      const res = await axios.post("/trip/get/tripsByDateRange", data);
      if (res.data.success) {
        // console.log('data get');

        setTrips(res.data.trips);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  // --- HELPER FUNCTIONS ---

  /**
   * Generates formatted financial data for downloads and tables
   */
  const getFinancialDataList = (type = "overall") => {
    const isICL = process.env.REACT_APP_LOGO_NAME === "LOGISTICS ICL";

    let vals = {};
    if (type === "overall") {
      vals = {
        company: company,
        incoming: companyIncoming,
        lorry: lorry,
        lorryBal: lorryBalance,
        profit: isICL ? netProfit : profit,
        incentive: incentive,
        expense: expense,
        extra: extraAmount,
        profitDesc: isICL ? "dynamic differnce" : "sum of ton * 15",
      };
    } else if (type === "range") {
      vals = {
        company: companyDateWise,
        incoming: companyIncomingDateWise,
        lorry: lorryDateWise,
        lorryBal: lorryBalDateWise,
        profit: isICL ? netProfitDateWise : profitDateWise,
        incentive: incentiveDateWise,
        expense: expenseDateWise,
        extra: undefined,
        profitDesc: isICL ? "dynamic differnce" : "sum of ton * 15",
      };
    } else {
      // tillDate
      vals = {
        company: companySum + (threshold?.companyTotal || 0),
        incoming:
          incomingCompanyBalanceTillDate +
          (threshold?.incomingCompanyBalance || 0),
        lorry: lorrySum + (threshold?.lorryTotal || 0),
        lorryBal: companyBalanceTillDate + (threshold?.lorryBalance || 0),
        profit: isICL ? netProfitTillDate : profitTillDate,
        incentive: incentiveTillDate,
        expense: expenseTillDate,
        extra: extraAmtTillDate,
        profitDesc: isICL ? "dynamic differnce" : "sum of ton * 15",
      };
    }

    const typeLabel =
      type === "overall"
        ? "Overall "
        : type === "range"
          ? "Range "
          : "Till Date ";

    const data = [
      {
        description: `${typeLabel}Total of Company Amount`,
        amount: vals.company,
      },
      {
        description: `${typeLabel}Incoming Balance of Company Amount`,
        amount: vals.incoming,
      },
      { description: `${typeLabel}Total of Lorry Amount`, amount: vals.lorry },
      { description: `${typeLabel}Balance of Lorry`, amount: vals.lorryBal },
      {
        description: `${typeLabel}Estimated Profit (${vals.profitDesc})`,
        amount: vals.profit,
      },
      { description: `${typeLabel}total Incentive`, amount: vals.incentive },
      { description: `${typeLabel}total expenses`, amount: vals.expense },
      {
        description: `${typeLabel}Profit ((Estimated Profit + Incentive) - Expenses)`,
        amount:
          Number(vals.profit || 0) +
          Number(vals.incentive || 0) -
          Number(vals.expense || 0),
      },
    ];

    if (vals.extra !== undefined) {
      data.push({
        description: `${typeLabel}Sum of Extra Amount`,
        amount: vals.extra,
      });
    }

    return data;
  };

  const handleOverAllDownload = () => {
    const financialData = getFinancialDataList("overall").map((item) => ({
      description: item.description,
      amount: item.amount?.toLocaleString("en-IN"),
    }));

    const workSheet = xlsx.utils.json_to_sheet(financialData);
    const workBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(workBook, "OverAllFinancialData.xlsx");
  };

  const handleRangeDownload = () => {
    const financialData = getFinancialDataList("range").map((item) => ({
      description: item.description,
      amount: item.amount?.toLocaleString("en-IN"),
    }));

    const workSheet = xlsx.utils.json_to_sheet(financialData);
    const workBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(workBook, "RangedFinancialData.xlsx");
  };

  const handleTillDateDownload = () => {
    const financialData = getFinancialDataList("tillDate").map((item) => ({
      description: item.description,
      amount: item.amount?.toLocaleString("en-IN"),
    }));

    const workSheet = xlsx.utils.json_to_sheet(financialData);
    const workBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(workBook, "TillDateFinancialData.xlsx");
  };

  const handleTripDataDownload = () => {
    let sheet = [];
    trips?.forEach((trip) => {
      const formatDate = (date) => new Date(date).toLocaleDateString("en-GB");
      let date =
        new Date(trip.tripDate).toLocaleDateString("en-GB") +
        "-" +
        new Date(trip.tripDate).toLocaleTimeString("en-GB");
      let obj = {
        tripDate: date,
        gpiNo: trip.gpiNo || 0,
        ton: trip.ton || 0,
        lrNo: trip.lrNo || "",
        truckNo: trip.truckNo || "",
        destination: trip.destination || "",
        threePointAmount: trip.threePointAmount || 0,
        threePointBill: trip.threePointBill || "",
        threePointDate: trip.threePointDate
          ? formatDate(trip.threePointDate)
          : "",
        companyRate: trip.companyRate || 0,
        companyTotal: trip.companyTotal || 0,
        lorryRate: trip.lorryRate || 0,
        lorryTotal: trip.lorryTotal || 0,
        advancedAmount: trip.advancedAmount || 0,
        advancedAmountDate: trip.advancedAmountDate
          ? formatDate(trip.advancedAmountDate)
          : "",
        dieselAmount: trip.dieselAmount || 0,
        balanceAmount: trip.balanceAmount || 0,
        billNo: trip.billNo || "",
        billDate: trip.billDate ? formatDate(trip.billDate) : "",
        tollBillNo: trip.tollBillNo || "",
        tollAmount: trip.tollAmount || 0,
        tollDate: trip.tollDate ? formatDate(trip.tollDate) : "",
        soldToParty: trip.soldToParty || "",
        contactNo: trip.contactNo || 0,
        postPaidAmount: trip.postPaidAmount || 0,
        postPaidDate: trip.postPaidDate ? formatDate(trip.postPaidDate) : "",
        postPaid2Amount: trip.postPaid2Amount || 0,
        postPaid2Date: trip.postPaid2Date ? formatDate(trip.postPaid2Date) : "",
        postPaid3Amount: trip.postPaid3Amount || 0,
        postPaid3Date: trip.postPaid3Date ? formatDate(trip.postPaid3Date) : "",
        extraAmount: trip.extraAmount || 0,
        extraAmountRemark: trip.extraAmountRemark || "",
        unloading: trip.unloading || 0,
      };

      sheet.push(obj);
    });

    const workSheet = xlsx.utils.json_to_sheet(sheet);
    const workBook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    xlsx.writeFile(workBook, "TripDataByRange.xlsx");
  };

  //submitting threshold amount in db

  const handleThreshold = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    // console.log(data);

    try {
      const response = await axios.post("/trip/addThresholdAmount", data);
      if (response.data.success) {
        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const getThresholds = async () => {
    try {
      const response = await axios.get("/trip/get/thresholds");
      if (response.data.success) {
        setThresholds(response.data.threshold);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const calculateUptillDate = async (e) => {
    e.preventDefault();
    setShowDownloadIconGivenDate(true);
    setShowTillDateChart(false);
    const form = new FormData(e.target);
    const data = Object.fromEntries(form.entries());
    let { endDate } = data;

    // console.log(data);

    try {
      if (process.env.REACT_APP_LOGO_NAME === "LOGISTICS UTCL") {
        const res5 = await axios.get(
          `/trip/get/profitTillDate?date=${endDate}`,
        );
        if (res5.data.success) {
          setProfitTillDate(res5.data.profitTillDate);
        }
      } else {
        const res5 = await axios.get(
          `/trip/get/net-profit/byTillDate?date=${endDate}`,
        );
        if (res5.data.success) {
          setNetProfitTillDate(res5.data.netProfit);
        }
      }

      const res = await axios.get("/trip/get/thresholds");
      if (res.data.success) {
        setThreshold(res.data.threshold[0]);
      }

      const response = await axios.post("/trip/lorrySumTillDate", data);
      if (response.data.success) {
        setLorrySum(response.data.lorryTotal);
      }

      const response2 = await axios.post("/trip/compantSumTillDate", data);
      if (response2.data.success) {
        setCompanySum(response2.data.companyTotal);
      }

      const res3 = await axios.post(
        "/trip/sumTillDateOfCompBalInceAmtExtraAmt",
        data,
      );
      if (res3.data.success) {
        setCompanyBalanceTillDate(res3.data.companyBalance);
        setExtraAmtTillDate(res3.data.extraAmount);
        setIncentiveTillDate(res3.data.incentiveAmount);
      }

      const res4 = await axios.post(
        "/trip/getSumTillDateOfIncomingCompanyBalance",
        data,
      );
      if (res4.data.success) {
        setIncomingCompanyBalanceTillDate(res4.data.incomingCompanyBalance);
      }

      const res6 = await axios.get(
        `/expenses/get/totalExpenseTillDate?date=${endDate}`,
      );
      if (res6.data.success) {
        setExpenseTillDate(res6.data.totalExpensesTillDate);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="m-4 flex justify-center flex-col items-center gap-2">
        {/* --- SECTION 1: OVERALL CALCULATIONS --- */}
        <div className="flex">
          <h2>
            Overall Calculations{" "}
            <i
              class=" ml-5 fa-solid fa-file-export text-lg  items-baseline text-orange-300 cursor-pointer"
              onClick={handleOverAllDownload}
              title="Download Report"
            ></i>
          </h2>
          {showChart ? (
            <i
              onClick={() => setShowChart(false)}
              title="Click to view Table"
              className="fa-solid fa-table-list ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
            ></i>
          ) : (
            <i
              onClick={getChart}
              title="Click to view Chart"
              className="fa-solid fa-chart-simple ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
            ></i>
          )}
        </div>

        {/* Closing Amounts Control */}
        <div className="flex items-center justify-center gap-2">
          <Popover placement="bottom" showArrow offset={10}>
            <PopoverTrigger>
              <Button color="primary">Set Closing Amounts</Button>
            </PopoverTrigger>
            <PopoverContent className="w-[400px]">
              {(titleProps) => (
                <div className="px-1 py-2 w-full">
                  <p
                    className="text-small font-bold text-foreground"
                    {...titleProps}
                  >
                    Add Closing Amounts
                  </p>
                  <form
                    onSubmit={handleThreshold}
                    className="mt-2 flex flex-col gap-2 w-full"
                  >
                    <Input
                      type="number"
                      name="companyTotal"
                      label="Company Total"
                      size="sm"
                      variant="bordered"
                    />
                    <Input
                      type="number"
                      name="lorryTotal"
                      label="Lorry Total"
                      size="sm"
                      variant="bordered"
                    />
                    <Input
                      type="number"
                      name="lorryBalance"
                      label="Lorry Balance"
                      size="sm"
                      variant="bordered"
                    />
                    <Input
                      type="number"
                      name="incomingCompanyBalance"
                      label="Incoming Company Balance"
                      size="sm"
                      variant="bordered"
                    />
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </form>
                </div>
              )}
            </PopoverContent>
          </Popover>

          <Button
            onPress={() => {
              onOpen();
              getThresholds();
            }}
            color="primary"
            className="text-sm"
          >
            <i class="fa-solid fa-eye"></i>
          </Button>

          <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
            <ModalContent>
              {(onClose) => (
                <>
                  <ModalHeader className="flex flex-col gap-1">
                    Amounts added list:
                  </ModalHeader>
                  <ModalBody>
                    <h2>Company Total: {thresholds[0]?.companyTotal}</h2>
                    <h2>Lorry Total: {thresholds[0]?.lorryTotal}</h2>
                    <h2>Lorry Balance: {thresholds[0]?.lorryBalance}</h2>
                    <h2>
                      Incoming company balance:{" "}
                      {thresholds[0]?.incomingCompanyBalance}
                    </h2>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" variant="light" onPress={onClose}>
                      Close
                    </Button>
                  </ModalFooter>
                </>
              )}
            </ModalContent>
          </Modal>
        </div>

        {/* Overall View (Chart or Table) */}
        {showChart ? (
          <div className="min-h-[32rem] min-w-[65rem]">
            <ProfitLossChart chrtData={chartData} />
          </div>
        ) : (
          <SummaryTable data={getFinancialDataList("overall")} />
        )}

        {/* --- SECTION 2: CALCULATIONS BASED ON DATE RANGE --- */}
        <h2 className="mt-4">
          Calculations based on Date
          {showDownloadIcon && (
            <>
              <i
                class=" ml-5 fa-solid fa-file-export text-lg  items-baseline text-orange-300 cursor-pointer"
                onClick={handleRangeDownload}
                title="Download Report"
              ></i>

              {showRangeChart ? (
                <i
                  onClick={() => setShowRangeChart(false)}
                  title="Click to view Table"
                  class="fa-solid fa-table-list ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
                ></i>
              ) : (
                <i
                  onClick={getRangeChart}
                  title="Click to view Chart"
                  class="fa-solid fa-chart-simple ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
                ></i>
              )}
            </>
          )}
        </h2>

        <div>
          <form
            onSubmit={handleSubmit}
            className="flex items-center gap-5 mt-4 bg-gray-300 p-2 rounded-lg"
          >
            <Input
              type="date"
              name="startDate"
              label={"Start date"}
              className="w-[300px]"
            />
            <Input
              type="date"
              name="endDate"
              label={"End date"}
              className="w-[300px]"
            />
            <Button
              type="submit"
              color="primary"
              className="font-bold hover:border hover:border-black"
            >
              <i class="fa-solid fa-calculator"></i>calculate
            </Button>
          </form>
        </div>

        {/* Detailed Trip Data (Range Only) */}
        {showDownloadIcon && (
          <TripDataTable
            trips={trips}
            handleTripDataDownload={handleTripDataDownload}
          />
        )}

        {/* Range Summary View (Chart or Table) */}
        {showRangeChart ? (
          <div className="min-h-[32rem] min-w-[65rem]">
            <ProfitLossChart chrtData={rangeChartData} />
          </div>
        ) : (
          <SummaryTable data={getFinancialDataList("range")} />
        )}

        {/* --- SECTION 3: CALCULATIONS UPTO GIVEN DATE --- */}
        <h2 className="mt-4">
          Calculations Upto given date
          {showDownloadIconGivenDate && (
            <>
              <i
                class=" ml-5 fa-solid fa-file-export text-lg  items-baseline text-orange-300 cursor-pointer"
                onClick={handleTillDateDownload}
                title="Download Report"
              ></i>
              {showTillDateChart ? (
                <i
                  onClick={() => setShowTillDateChart(false)}
                  title="Click to view Table"
                  class="fa-solid fa-table-list ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
                ></i>
              ) : (
                <i
                  onClick={getTillDateChart}
                  title="Click to view Chart"
                  class="fa-solid fa-chart-simple ml-5 text-2xl items-baseline  text-orange-300 cursor-pointer"
                ></i>
              )}
            </>
          )}
        </h2>

        <div>
          <form
            onSubmit={calculateUptillDate}
            className="flex items-center gap-5 mt-4 bg-gray-300 p-2 rounded-lg"
          >
            <Input
              type="date"
              name="endDate"
              label={"End date"}
              className="w-[300px]"
            />
            <Button
              type="submit"
              color="primary"
              className="font-bold hover:border hover:border-black"
            >
              <i class="fa-solid fa-calculator"></i>calculate
            </Button>
          </form>
        </div>

        {/* Till Date Summary View (Chart or Table) */}
        {showTillDateChart ? (
          <div className="min-h-[32rem] min-w-[65rem]">
            <ProfitLossChart chrtData={tillDateChartData} />
          </div>
        ) : (
          <SummaryTable data={getFinancialDataList("tillDate")} />
        )}
      </div>
    </>
  );
};

export default Analytics;
